export enum CharitableGivingTab {
  Overview = 'Overview',
  Assumptions = 'Assumptions',
}
